module.exports = __webpack_public_path__ + "img/brand-4.92a7921f.png";